import { render, staticRenderFns } from "./activity_result_edit.vue?vue&type=template&id=401dafe5&scoped=true&"
import script from "./activity_result_edit.vue?vue&type=script&lang=js&"
export * from "./activity_result_edit.vue?vue&type=script&lang=js&"
import style0 from "./activity_result_edit.vue?vue&type=style&index=0&id=401dafe5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401dafe5",
  null
  
)

export default component.exports